let trialCountDownTemplate = require('../../templates/trial-countdown.html');
let client = require('sci/helpers/client');
const Vue = require('vue')

Vue.component('trial-countdown', {
    props:[],
    template: trialCountDownTemplate,
    data: () => ({
        expiration: {}
    }),

    ready(){
        this.display();
    },
    methods: {
        display () {
            client
                .get('Aguarde', '/settings')
                .then((data) => {
                    this.expiration = data.data.trial.expires_at;
                    this.expiration = new Date(this.expiration);
                    // if(!this.expiration)
                    // {
                    //     return this.expiration;
                    // }
                })
        }
    }
});




// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/trial-countdown.js